export const low = '0 3px 9px 0 rgba(0, 0, 0, 0.1)',
    medium = '0 7px 21px 0 rgba(0, 0, 0, 0.1)',
    high = '0 14px 42px 0 rgba(0, 0, 0, 0.2)',
    button = '0 6px 20px 0 rgba(0,0,0,0.2)';
